/* Freedom Range theme scripts: menu, cart drawer, AJAX add, variant picker,
   sticky add-to-bag, hero word cycle, chapter rail, reveal-on-scroll. */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var money = function (cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100);
  };
  var esc = function (s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; };

  // ---- Mobile menu ---------------------------------------------------------
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-menu-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open);
  });

  // ---- Cart drawer ---------------------------------------------------------
  var drawer = document.getElementById('CartDrawer');
  var lastFocus = null;

  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.add('is-bumped');
      setTimeout(function () { el.classList.remove('is-bumped'); }, 900);
    });
  }

  function renderCart(cart) {
    if (!drawer) return;
    var list = drawer.querySelector('[data-drawer-items]');
    if (!cart.items.length) {
      list.innerHTML = '<p class="drawer__empty">Your bag is empty.</p>';
    } else {
      list.innerHTML = cart.items.map(function (item) {
        var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<small>' + esc(item.variant_title) + ' · Qty ' + item.quantity + '</small>' : '<small>Qty ' + item.quantity + '</small>';
        return '<div class="drawer__item">' +
          (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
          '<div><b>' + esc(item.product_title) + '</b>' + variant + '<br><button type="button" data-remove="' + esc(item.key) + '">Remove</button></div>' +
          '<div>' + money(item.final_line_price) + '</div></div>';
      }).join('');
    }
    drawer.querySelector('[data-drawer-total]').textContent = money(cart.total_price);
    shipBar(cart.total_price);
  }

  function shipBar(total) {
    var bar = document.querySelector('[data-ship-bar]');
    if (!bar) return;
    var th = parseInt(bar.dataset.threshold, 10) || 0;
    var left = th - total;
    bar.querySelector('[data-ship-msg]').innerHTML = left > 0
      ? 'You’re <b>' + money(left) + '</b> away from <b>free UK delivery</b>'
      : 'You’ve unlocked <b>free UK delivery</b>';
    bar.querySelector('[data-ship-fill]').style.width = Math.min(100, Math.round(total / th * 100)) + '%';
    bar.classList.toggle('is-done', left <= 0);
  }
  (function () { var b = document.querySelector('[data-ship-bar]'); if (b) shipBar(parseInt(b.dataset.total, 10) || 0); })();

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }
  function refreshCart() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      setCount(cart.item_count);
      renderCart(cart);
      return cart;
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) { closeDrawer(); return; }
    var opener = e.target.closest('[data-drawer-open]');
    if (opener && drawer) { e.preventDefault(); refreshCart().then(openDrawer); return; }
    var remove = e.target.closest('[data-remove]');
    if (remove) {
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.remove, quantity: 0 })
      }).then(refreshCart);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // ---- AJAX add to bag (product page + quick add) --------------------------
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();

    var button = e.submitter || form.querySelector('[type="submit"]');
    var original = button.innerHTML;
    button.disabled = true;

    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); })
      .then(refreshCart)
      .then(function () {
        button.innerHTML = button.closest('.card__sizes') ? '✓' : 'Added ✓';
        if (drawer) openDrawer();
      })
      .catch(function (err) { button.innerHTML = (err && err.description) || 'Try again'; })
      .finally(function () {
        setTimeout(function () { button.innerHTML = original; button.disabled = false; }, 1600);
      });
  });

  // ---- Quantity buttons ----------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.qty, 10));
  });

  // ---- Size guide ------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var dlg = document.getElementById('SizeGuide');
    if (!dlg) return;
    if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
    else if (e.target.closest('[data-size-guide-close]') || e.target === dlg) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
  });

  // ---- Country / language switcher -----------------------------------------
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-localization-select]')) e.target.form.submit();
  });

  // ---- Variant picker + honest low-stock note ------------------------------
  var form = document.getElementById('ProductForm');
  var jsonEl = document.querySelector('[data-product-json]');
  if (form && jsonEl) {
    var data = JSON.parse(jsonEl.textContent);
    var variants = data.variants;
    var stock = data.stock || {};
    var addBtn = form.querySelector('[data-add-button]');
    var stickyBtn = document.querySelector('[data-sticky-add]');
    var stockNote = document.querySelector('[data-stock-note]');

    var update = function (variant) {
      var label;
      if (!variant) { label = 'Unavailable'; }
      else { label = variant.available ? 'Add to bag · ' + money(variant.price) : 'Sold out'; }
      [addBtn, stickyBtn].forEach(function (b) { if (b) { b.disabled = !variant || !variant.available; b.textContent = label; } });
      var notify = document.querySelector('[data-notify]');
      if (notify) {
        var done = notify.querySelector('[data-notify-done]');
        notify.hidden = !done && (!variant || variant.available);
        var nv = notify.querySelector('[data-notify-variant]');
        if (nv && variant) nv.value = variant.title;
      }
      if (!variant) return;
      form.querySelector('[data-variant-id]').value = variant.id;
      var priceEl = document.querySelector('[data-price]');
      if (priceEl) priceEl.innerHTML = (variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '') + money(variant.price);
      if (stockNote) {
        var q = stock[variant.id];
        stockNote.textContent = variant.available && q > 0 && q <= 5 ? 'Only ' + q + ' left in ' + variant.title : '';
      }
    };

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var selected = [];
      form.querySelectorAll('[data-option-index]:checked').forEach(function (input) {
        selected[input.dataset.optionIndex] = input.value;
        var label = form.querySelector('[data-option-label="' + input.dataset.optionIndex + '"]');
        if (label) label.textContent = input.value;
      });
      var variant = variants.find(function (v) { return v.options.every(function (opt, i) { return opt === selected[i]; }); });
      update(variant);
      if (variant) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    });
    var initial = variants.find(function (v) { return String(v.id) === form.querySelector('[data-variant-id]').value; });
    update(initial);

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click(); });
      var bar = stickyBtn.closest('.sticky-atc');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
        }).observe(addBtn);
      }
    }
  }

  // ---- Collection sort -----------------------------------------------------
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-sort-select]')) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  // ---- Hero: "freedom" in the languages of the people we stand with --------
  document.querySelectorAll('[data-cycle]').forEach(function (el) {
    var label = el.parentElement.querySelector('[data-cycle-label]');
    var raw = el.dataset.cycle;
    var items = (raw.indexOf('|') > -1 ? raw.split(/\n/) : raw.split(',')).map(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      return { word: p[0], label: p[1] || '', lang: p[2] || '' };
    }).filter(function (x) { return x.word; });
    if (items.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      el.classList.add('is-out');
      if (label) label.style.opacity = 0;
      setTimeout(function () {
        i = (i + 1) % items.length;
        el.textContent = items[i].word;
        el.setAttribute('lang', items[i].lang);
        if (label) { label.textContent = items[i].label; label.style.opacity = 1; }
        el.classList.remove('is-out');
      }, 500);
    }, 2800);
  });

  // ---- Chapters rail arrows ------------------------------------------------
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-prev], [data-rail-next]');
    if (!btn) return;
    var rail = btn.closest('section').querySelector('[data-rail]');
    var card = rail.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : 300;
    rail.scrollBy({ left: btn.hasAttribute('data-rail-next') ? step : -step, behavior: reduce ? 'auto' : 'smooth' });
  });

  // ---- Reveal on scroll (content is never hidden without JS or IO) ----------
  if ('IntersectionObserver' in window && !reduce) {
    document.documentElement.classList.add('js-reveal');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    var watch = function () { document.querySelectorAll('.reveal:not(.is-in)').forEach(function (el) { io.observe(el); }); };
    watch();
    window.addEventListener('load', watch);
    // Failsafe: never leave content invisible.
    setTimeout(function () { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
  }
})();
